import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["type", "id", "name", "value", "min", "disabled", "error", "placeholder", "maxlength"]
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("input", {
      type: _ctx.type,
      id: _ctx.id,
      name: _ctx.name,
      value: _ctx.value,
      min: _ctx.min,
      class: _normalizeClass(["c-input-text", {
        'c-input-text--error': _ctx.error,
        'c-input-text--has_icon': _ctx.hasIcon,
        'c-input-text--has_suffix': _ctx.hasSuffix
      }]),
      disabled: _ctx.disabled,
      error: _ctx.error,
      placeholder: _ctx.placeholder,
      maxlength: _ctx.maxlength,
      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateValue && _ctx.updateValue(...args))),
      onFocus: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.focus && _ctx.focus(...args))),
      onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.blur && _ctx.blur(...args)))
    }, null, 42, _hoisted_1),
    (_ctx.$slots.lastLabel)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _renderSlot(_ctx.$slots, "lastLabel", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ]))
}